import type {
  IGetCategoriesResponseBody,
  IGetCategoryPageBySlugResponseBody,
  IGetEventAggregatedBySlugRequestParams,
} from "~/feature/categories/type";
import { api } from "~/store/api";

const API_PREFIX = "/categories";

export const categoriesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<IGetCategoriesResponseBody, void>({
      query: () => ({
        url: `${API_PREFIX}/by-volume`,
      }),
    }),
    getCategoryPageBySlug: builder.query<
      IGetCategoryPageBySlugResponseBody,
      IGetEventAggregatedBySlugRequestParams
    >({
      query: ({ slug, ...params }) => ({
        url: `${API_PREFIX}/slug/${slug}`,
        params,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetCategoriesQuery } = categoriesApi;
